<template>
	<div class='view'>
		<VueGallery 
			:images='images'
			:index='imgIndex'
			@close='imgIndex = null' />
		<div class='hobbies-view'>
			<section class='hobby'>
			<article class='hobby__info'>
				<h2>Bouldering & Climbing</h2>
				<p>I discovered this great activity several years ago. I try to do it at least once a week. Still haven't climbed in the nature so this is on my todo list.</p>
			</article>
			<div class='hobby__image'>
				<img src='../assets/hobbies/climber.jpg' class='image' />
			</div>
			</section>

			<section class='hobby'>
				<div class='hobby__image'>
					<img src='../assets/hobbies/painter.jpg' class='image' />
				</div>
				<article class='hobby__info'>
					<h2>Painitng</h2>
					<p>I have been painting and drawing on and off from early childhood. I have been doing mostly canvas works but lately I started experimenting with pour acrylics, vector drawings and wall art.</p>
					<p>You can <strong class='gallery-link' @click='imgIndex = 0'>check out</strong> some of the things I do.</p>
				</article>
			</section>
		</div>
	</div>
</template>

<script>
import VueGallery from 'vue-gallery';

export default {
	name: 'Other',

	components: {
		VueGallery
	},

	data() {
		return {
			imgIndex: null,
			images: [
                require('@/assets/hobbies/paintings/paints/1.jpg'),
                require('@/assets/hobbies/paintings/paints/2.jpg'),
                require('@/assets/hobbies/paintings/paints/3.jpg'),
                require('@/assets/hobbies/paintings/paints/4.jpg'),
                require('@/assets/hobbies/paintings/paints/5.jpg'),
                require('@/assets/hobbies/paintings/vector/1.jpg'),
                require('@/assets/hobbies/paintings/vector/2.jpg'),
                require('@/assets/hobbies/paintings/vector/3.jpg'),
                require('@/assets/hobbies/paintings/vector/4.jpg'),
                require('@/assets/hobbies/paintings/vector/5.jpg'),
                require('@/assets/hobbies/paintings/vector/6.jpg'),
                require('@/assets/hobbies/paintings/vector/7.jpg'),
            ],
		}
	}
}
</script>

<style lang='less' scoped>
@import '../colours';

.hobbies-view {
	display: grid;
	grid-template-columns: 1fr 150px 1fr;
}

.hobby {

	&:nth-child(1) {
		grid-column: 1 / span 1;
	}

	&:nth-child(2) {
		grid-column: 3 / span 1;
	}
}

.hobby__info {
	flex: 1;
} 

.hobby__image {
	flex: 2;
	margin: 0 auto;
}

.image {
	max-width: 100%;
	height: auto;
	margin: 20px;
}

.gallery-link {
	background-color: black;
	color: white;
	padding: 0 5px;
	cursor: pointer;
}

@media screen and (max-width: 1200px) {
	
	.hobbies-view {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.hobby {
		display: flex;
		flex-direction: column;

		&:nth-child(2) {
			flex-direction: column-reverse;
		}
	}

	.hobby__image {
		flex: 1;
		max-width: 440px;
	}
}

@media screen and (max-width: 960px) {

	.image {
		max-width: 340px;
	}

	.hobby {
		flex-direction: column;
		align-self: center;

		&:nth-child(2) {
			flex-direction: column-reverse;
		}
	}
}

@media screen and (max-width: 550px) {

	.hobby__image {
		max-width: 300px;
	}

	.image {
		max-width: 260px;
	}
}

@media screen and (max-width: 355px) {

	.hobby__image {
		max-width: 260px;
	}

	.image {
		max-width: 220px;
	}
}

</style>